import React, { useContext } from "react";
import { Col, Modal, Row, Spin } from "antd";
import styles from "./index.module.scss";
import AllStuInfo from "./components/AllStuInfo";
import AllExamInfo from "./components/AllExamInfo";
import AllExamLog from "./components/AllExamLog";
import { InvigilationCtx } from "../../../context";
import { getStudentExamLog } from "../../../../../../service/exam";
import useRequest from "../../../../../../utils/useRequest";
import ReloadBtn from "../../../components/ReloadBtn";

export default function AllModal({ ...props }) {
    const { currentData, reloadAll, reloadKey } = useContext(InvigilationCtx);
    const [data, { loading }, reload] = useRequest(
        () =>
            getStudentExamLog({
                examId: currentData?.examId || 0,
                studentNo: currentData?.studentNo || ""
            }),
        {},
        [currentData]
    );

    function Reload() {
        reloadAll();
        reload();
    }

    const Titles = (
        <div className={styles.titles}>
            <span>查看参考全过程情况</span>
            <ReloadBtn onReload={Reload} />
        </div>
    );

    return (
        <Modal {...props} className={styles.root} title={Titles} footer={false}>
            <Spin spinning={loading}>
                <Row type="flex" key={JSON.stringify(reloadKey)}>
                    <Col span={5}>
                        <AllStuInfo />
                    </Col>
                    <Col span={10}>
                        <AllExamInfo data={data} />
                    </Col>
                    <Col span={9}>
                        <AllExamLog loading={false} data={data} />
                    </Col>
                </Row>
            </Spin>
        </Modal>
    );
}
